import React, { useState } from 'react';
import styled from 'styled-components';
import { object, array, func, string } from 'prop-types';
import { get, filter, isEmpty, split, trim, head, replace } from 'lodash';
import { withApollo } from 'react-apollo';
import { FormSelect, Button, Row, FlexContainer } from '../../common';
import { UPDATE_COMERCIAL_POLICY_REFERENCE } from '../../../queries';

const SpaceBetween = styled.div`
    width: ${({ width }) => width};
`;

const Header = ({ client, salesChannelOptions, refetchQuery, currentValue }) => {
    const [comercialPolicy, setComercialPolicy] = useState(null);
    const [comercialPolicyOut, serComercialPolicyOut] = useState(null);
    const [loading, setLoading] = useState(false);
    const fullWidth = currentValue === '100%';
    const spaceBetweenWidth = fullWidth ? '0px' : '13px';

    const handleButton = async () => {
        setLoading(true);
        await client.mutate({
            mutation: UPDATE_COMERCIAL_POLICY_REFERENCE,
            variables: {
                comercial_policy: get(comercialPolicy, 'value'),
                comercial_policy_out: get(comercialPolicyOut, 'value')
            }
        });
        refetchQuery();
        setLoading(false);
    };

    const idCleaned = () => {
        return trim(head(split(get(comercialPolicy, 'label'), '-')));
    };

    return (<div style={{ padding: '23px 0px' }}>
        <Row
            border='1px solid #eaeaea'
            borderRadius={3}
            padding='3px 13px'
            backgroundColor='white'
        >
            <FormSelect
                label='Tienda'
                placeholder='Seleccione tienda'
                options={salesChannelOptions}
                value={comercialPolicy}
                width={currentValue}
                onChange={({ value }) => setComercialPolicy(value)}
            />
            <SpaceBetween width={spaceBetweenWidth} />
            <FormSelect
                disabled={isEmpty(comercialPolicy)}
                label='Código de ubicación'
                placeholder='Seleccione código de ubicación'
                options={filter(salesChannelOptions, ({ id }) => id === idCleaned())}
                style={{ width: `${parseInt(replace(currentValue, '%', '')) * 2}%` }}
                value={comercialPolicyOut}
                onChange={({ value }) => serComercialPolicyOut(value)}
            />
            <SpaceBetween width={spaceBetweenWidth} />
            <FlexContainer
                width={fullWidth ? '100%' : undefined}
                align='flex-end'
            >
                <Button
                    loading={loading}
                    bottom={10}
                    text={'Asociar'}
                    onClick={() => handleButton()}
                />
            </FlexContainer>
        </Row>
    </div>);
};

Header.propTypes = {
    client: object,
    salesChannelOptions: array,
    refetchQuery: func,
    currentValue: string
};

export default withApollo(Header);
